// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore TODO: improve this
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()
